export const MAX_NUMBER_OF_UIM_APPS = 5;
